"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = "\n.code-editor {\n  display: block;\n  white-space: pre;\n\n  background-color: #1D1F21;\n  color: #C5C8C6;\n\n  padding: 0.5rem;\n  margin: 0;\n\n  box-sizing: border-box;\n  vertical-align: baseline;\n  outline: none;\n  text-shadow: none;\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n  word-wrap: normal;\n  word-break: normal;\n  text-align: left;\n  word-spacing: normal;\n  -moz-tab-size: 2;\n  -o-tab-size: 2;\n  tab-size: 2;\n}\n.code-editor .prefix-code, .code-editor .prefix-code * {\n  cursor: not-allowed;\n}\n";


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/constants/css.js